import script from "./TabGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./TabGroup.vue?vue&type=script&setup=true&lang=js"

import "./TabGroup.vue?vue&type=style&index=0&id=424869c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-424869c3"]])

export default __exports__